var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbidadeh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4055 13.5172H36.2616L36.6886 14.254L36.2616 14.9973H35.4055L34.9774 14.254L35.4055 13.5172Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4055 13.5172H36.2616L36.6886 14.254L36.2616 14.9973H35.4055L34.9774 14.254L35.4055 13.5172Z",
    fill: "url(#paint0_linear_1867_205)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0499 13.1386H33.3437L33.989 14.2521L33.3437 15.3754H32.0499L31.403 14.2521L32.0499 13.1386Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0499 13.1386H33.3437L33.989 14.2521L33.3437 15.3754H32.0499L31.403 14.2521L32.0499 13.1386Z",
    fill: "url(#paint1_linear_1867_205)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8259 12.3789H28.9984L30.0819 14.2486L28.9984 16.1349H26.8259L25.7396 14.2486L26.8259 12.3789Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8259 12.3789H28.9984L30.0819 14.2486L28.9984 16.1349H26.8259L25.7396 14.2486L26.8259 12.3789Z",
    fill: "url(#paint2_linear_1867_205)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7148 11.9177L24.0719 14.2532L22.7126 16.586L19.9816 16.5995L18.6244 14.264L20 11.918L22.7148 11.9177Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7148 11.9177L24.0719 14.2532L22.7126 16.586L19.9816 16.5995L18.6244 14.264L20 11.918L22.7148 11.9177Z",
    fill: "url(#paint3_linear_1867_205)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8649 19.3588H39.721L40.148 20.0956L39.721 20.8389H38.8649L38.4368 20.0956L38.8649 19.3588Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8649 19.3588H39.721L40.148 20.0956L39.721 20.8389H38.8649L38.4368 20.0956L38.8649 19.3588Z",
    fill: "url(#paint4_linear_1867_205)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5091 18.9805H36.8029L37.4482 20.094L36.8029 21.2173H35.5091L34.8622 20.094L35.5091 18.9805Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5091 18.9805H36.8029L37.4482 20.094L36.8029 21.2173H35.5091L34.8622 20.094L35.5091 18.9805Z",
    fill: "url(#paint5_linear_1867_205)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2853 18.2213H32.4578L33.5413 20.091L32.4578 21.9772H30.2853L29.199 20.091L30.2853 18.2213Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2853 18.2213H32.4578L33.5413 20.091L32.4578 21.9772H30.2853L29.199 20.091L30.2853 18.2213Z",
    fill: "url(#paint6_linear_1867_205)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1741 17.7598L27.5312 20.0953L26.1719 22.4281L23.4409 22.4416L22.0837 20.1061L23.4593 17.7601L26.1741 17.7598Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1741 17.7598L27.5312 20.0953L26.1719 22.4281L23.4409 22.4416L22.0837 20.1061L23.4593 17.7601L26.1741 17.7598Z",
    fill: "url(#paint7_linear_1867_205)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0579 25.1848H42.914L43.341 25.9216L42.914 26.6649H42.0579L41.6298 25.9216L42.0579 25.1848Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0579 25.1848H42.914L43.341 25.9216L42.914 26.6649H42.0579L41.6298 25.9216L42.0579 25.1848Z",
    fill: "url(#paint8_linear_1867_205)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7021 24.8066H39.996L40.6412 25.92L39.996 27.0433H38.7021L38.0552 25.92L38.7021 24.8066Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7021 24.8066H39.996L40.6412 25.92L39.996 27.0433H38.7021L38.0552 25.92L38.7021 24.8066Z",
    fill: "url(#paint9_linear_1867_205)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4783 24.0468H35.6509L36.7344 25.9165L35.6509 27.8028H33.4783L32.3921 25.9165L33.4783 24.0468Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4783 24.0468H35.6509L36.7344 25.9165L35.6509 27.8028H33.4783L32.3921 25.9165L33.4783 24.0468Z",
    fill: "url(#paint10_linear_1867_205)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6442 23.5788H29.3585L30.7122 25.9148L29.3585 28.2714H26.6442L25.287 25.9148L26.6442 23.5788Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6442 23.5788H29.3585L30.7122 25.9148L29.3585 28.2714H26.6442L25.287 25.9148L26.6442 23.5788Z",
    fill: "url(#paint11_linear_1867_205)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7237 8.92082L40.1517 8.18418L39.723 7.44841L38.8616 7.44414L38.4335 8.18078L38.8674 8.92074L39.7237 8.92082Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7237 8.92082L40.1517 8.18418L39.723 7.44841L38.8616 7.44414L38.4335 8.18078L38.8674 8.92074L39.7237 8.92082Z",
    fill: "url(#paint12_linear_1867_205)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8071 9.29788L37.454 8.18465L36.806 7.07272L35.5043 7.06627L34.8574 8.1795L35.5131 9.29776L36.8071 9.29788Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8071 9.29788L37.454 8.18465L36.806 7.07272L35.5043 7.06627L34.8574 8.1795L35.5131 9.29776L36.8071 9.29788Z",
    fill: "url(#paint13_linear_1867_205)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4647 10.0554L33.551 8.18609L32.463 6.31895L30.2771 6.30812L29.1908 8.17744L30.2918 10.0552L32.4647 10.0554Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4647 10.0554L33.551 8.18609L32.463 6.31895L30.2771 6.30812L29.1908 8.17744L30.2918 10.0552L32.4647 10.0554Z",
    fill: "url(#paint14_linear_1867_205)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1741 10.5222L27.5312 8.18671L26.1719 5.85394L23.4409 5.84041L22.0837 8.17591L23.4593 10.522L26.1741 10.5222Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1741 10.5222L27.5312 8.18671L26.1719 5.85394L23.4409 5.84041L22.0837 8.17591L23.4593 10.522L26.1741 10.5222Z",
    fill: "url(#paint15_linear_1867_205)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.058 3.09695H42.9142L43.3411 2.36016L42.9142 1.61686H42.058L41.63 2.36016L42.058 3.09695Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.058 3.09695H42.9142L43.3411 2.36016L42.9142 1.61686H42.058L41.63 2.36016L42.058 3.09695Z",
    fill: "url(#paint16_linear_1867_205)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7023 3.47548H39.9961L40.6413 2.36202L39.9961 1.23872H38.7023L38.0554 2.36202L38.7023 3.47548Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7023 3.47548H39.9961L40.6413 2.36202L39.9961 1.23872H38.7023L38.0554 2.36202L38.7023 3.47548Z",
    fill: "url(#paint17_linear_1867_205)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6577 0.484497L36.744 2.35382L35.656 4.22096L33.4701 4.23179L32.3838 2.36247L33.4849 0.484692L35.6577 0.484497Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6577 0.484497L36.744 2.35382L35.656 4.22096L33.4701 4.23179L32.3838 2.36247L33.4849 0.484692L35.6577 0.484497Z",
    fill: "url(#paint18_linear_1867_205)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3672 0.0174561L30.7244 2.35296L29.3651 4.68573L26.6341 4.69926L25.2769 2.36376L26.6525 0.0176987L29.3672 0.0174561Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3672 0.0174561L30.7244 2.35296L29.3651 4.68573L26.6341 4.69926L25.2769 2.36376L26.6525 0.0176987L29.3672 0.0174561Z",
    fill: "url(#paint19_linear_1867_205)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.649 28.3256L16.4326 14.1632L8.21631 28.3256H24.649Z",
    fill: "#5C5C5C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.04628e-05 14.1631L16.4326 14.1632L8.21631 28.3256L-1.04628e-05 14.1631Z",
    fill: "#333333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21828 0.00252888L24.6509 0.00253108L16.4346 14.1649L8.21828 0.00252888Z",
    fill: "#2E2E2E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4348 14.1624L0.00209925 14.1624L8.21843 0L16.4348 14.1624Z",
    fill: "#191919"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1867_205",
    x1: 30.9828,
    y1: 0.0174561,
    x2: 19.8474,
    y2: 22.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbidadeh);
export default __webpack_public_path__ + "static/media/abidadeh.56475f516d09bf73b7968b9b587a98b4.svg";
export { ForwardRef as ReactComponent };